export const UPDATE_PATCH_KEY_PREFIX = 'wm_update_patch_';
export const UPDATE_MINOR_KEY_PREFIX = 'wm_update_minor_';
export const UPDATE_MAJOR_KEY_PREFIX = 'wm_update_major_';

// Patch (opzionale): mostra il toast al massimo una volta ogni 6 ore.
export const UPDATE_PATCH_INTERVAL_MS = 6 * 60 * 60 * 1000;

// Minor (raccomandato): mostra il modal al massimo una volta ogni 2 ore.
export const UPDATE_MINOR_INTERVAL_MS = 2 * 60 * 60 * 1000;
